import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import MailConfigPage from "./MailConfigPage";
import TestMailPage from "./TestMailPage";

const tabStyle = (selected) => ({
  color: selected ? "#321ACB" : "#7E8299",
  borderBottom: selected ? "2px solid #321ACB" : "2px solid transparent",
});

export default function MailPage() {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(
    new URLSearchParams(location.search).get("tab") === "historial"
      ? "historial"
      : "configuracion"
  );

  return (
    <>
      <Card>
        <CardHeader title="Mail" />
        <CardBody>
          <div className="d-flex border-bottom" style={{ gap: "1.5rem" }}>
            <button
              type="button"
              className="border-0 bg-transparent font-weight-bolder pb-3"
              onClick={() => setSelectedTab("configuracion")}
              style={tabStyle(selectedTab === "configuracion")}
            >
              Configuración
            </button>
            <button
              type="button"
              className="border-0 bg-transparent font-weight-bolder pb-3"
              onClick={() => setSelectedTab("historial")}
              style={tabStyle(selectedTab === "historial")}
            >
              Histórico de mail
            </button>
          </div>
        </CardBody>
      </Card>

      {selectedTab === "configuracion" ? <MailConfigPage /> : <TestMailPage />}
    </>
  );
}
